import _extends from "@babel/runtime/helpers/esm/extends";
export default (function (_ref) {
  var staticProps = _ref.staticProps;
  var _staticProps$footerDa = staticProps.footerData,
    _staticProps$footerDa2 = _staticProps$footerDa === void 0 ? {} : _staticProps$footerDa,
    _staticProps$footerDa3 = _staticProps$footerDa2.certificatePartners,
    certificatePartners = _staticProps$footerDa3 === void 0 ? [] : _staticProps$footerDa3,
    _staticProps$footerDa4 = _staticProps$footerDa2.linksColumns,
    linksColumns = _staticProps$footerDa4 === void 0 ? [] : _staticProps$footerDa4,
    _staticProps$footerDa5 = _staticProps$footerDa2.contactSection,
    contactSection = _staticProps$footerDa5 === void 0 ? {} : _staticProps$footerDa5,
    _staticProps$footerDa6 = _staticProps$footerDa2.bottomInfo,
    bottomInfo = _staticProps$footerDa6 === void 0 ? {} : _staticProps$footerDa6,
    paymentMethods = _staticProps$footerDa2.paymentMethods,
    subscriptionForm = _staticProps$footerDa2.subscriptionForm;
  return {
    data: _extends({
      bottomInfo: bottomInfo,
      certificatePartners: certificatePartners,
      contactSection: contactSection,
      linksColumns: linksColumns
    }, paymentMethods && {
      paymentMethods: paymentMethods
    }, subscriptionForm && {
      subscriptionForm: subscriptionForm
    })
  };
});